<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import AppButton from '../../primitives/AppButton/AppButton.vue'
import { useChatRoute } from '@/composables/useChatRoute'
import { useChatStore } from '@/stores/chat'
import { isLoaded } from '@/types/load-state'
import { DESIGN_SUGGESTION_KEYS, showsDesignSuggestions } from './design-suggestions'

/** The edits a person is likely to want next, offered above the composer while a design chip is attached. */
const { t } = useI18n()
const chat = useChatStore()
const { withThreadAddress } = useChatRoute()

const visible = computed(() =>
  showsDesignSuggestions({
    attachment: chat.attachment,
    messages: isLoaded(chat.messages) ? chat.messages.value : [],
    busy: chat.sendStatus === 'submitting' || chat.sendStatus === 'streaming',
  }),
)

function pick(key: (typeof DESIGN_SUGGESTION_KEYS)[number]): void {
  void withThreadAddress(() => chat.send(t(`chat.designSuggestions.${key}`)))
}
</script>

<template>
  <div
    v-if="visible"
    role="group"
    :aria-label="t('chat.designSuggestions.label')"
    class="flex flex-wrap gap-4 pb-4"
  >
    <AppButton
      v-for="key in DESIGN_SUGGESTION_KEYS"
      :key
      variant="secondary"
      size="xs"
      radius="full"
      :label="t(`chat.designSuggestions.${key}`)"
      @click="pick(key)"
    />
  </div>
</template>
